import { Order } from 'src/shared/types/order';

import { addClientFlashMessage, removeClientFlashMessage } from './redux';

type PrimitiveType = string | number | boolean | null | undefined | Date;
export type TranslateParams = Record<string, PrimitiveType>;

export const addErrorFlashMessage = (message: string) =>
    addClientFlashMessage({ type: 'error', message });

interface Action {
    text: string;
    callback: () => void;
}

export const addSuccessFlashMessage = (message: string, action?: Action) =>
    addClientFlashMessage({ type: 'success', message, action });

export const addWarningFlashMessage = (message: string) =>
    addClientFlashMessage({ type: 'warning', message });

export const removeFlashMessage = () => removeClientFlashMessage();

export const getCustomerCareDetails = ({
    order,
    translate,
}: {
    order: Order | undefined;
    translate: (message: string, params?: TranslateParams) => string;
}) => {
    const countryCode = order && order.delivery_address.country_code;
    const params = countryCode
        ? {
              hotline: translate(`hotline_${countryCode}`),
              email: translate(`email_${countryCode}`),
          }
        : { hotline: '', email: '' };

    return params;
};
